import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';
import { STORY_AD_TYPES, PURCHASE_TYPES } from 'app/utils/constants';

const getStory = (id) => API.get(`/stories/${id}/`);

const getStoriesByIds = (ids = []) =>
  API.get(`/stories/?story_ids=${ids.join(',')}`);

const getStoryEpisodes = (
  storyId,
  ordering = 'newest',
  page = 1,
  perPage = 20
) => {
  const params = toParams({ page, perPage, ordering });
  return API.get(`/stories/${storyId}/episodes/?${params}`);
};

const getUserStories = (userId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/${userId}/stories/?${params}`);
};

const getUserOtherStories = (userId, storyId, page = 1, perPage = 10) => {
  const params = toParams({ excludeId: storyId, page, perPage });
  return API.get(`/users/${userId}/stories/?${params}`);
};

const getEpisode = (storyId, episodeId) =>
  API.get(`/stories/${storyId}/episodes/${episodeId}/`);

const getStoryRecommendations = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/recommended-stories/?${params}`);
};

const search = (q, page = 1, perPage = 20) => {
  const params = toParams({ q, page, perPage });
  return API.get(`/search/?${params}`);
};

// purchase
const purchaseEpisode = (storyId, episodeId, type) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/purchase/`, {
    type,
  });

const readEpisode = (storyId, episodeId, data) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/read/`, data);

// choice
const getPaidChoices = (storyId, episodeId) =>
  API.get(`/stories/${storyId}/episodes/${episodeId}/purchase-paid-choices/`);

const purchaseChoice = (storyId, episodeId, balloon, choiceId) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/purchase-paid-choices/`, {
    balloon,
    choiceId,
  });

const previewByBalloon = (storyId, episodeId, balloon, message) =>
  API.post(`/stories/${storyId}/episodes/${episodeId}/purchase/`, {
    balloon,
    type: PURCHASE_TYPES.PREVIEW,
    ...(message ? { message } : {}),
  });

// ad
const getStoryAd = (type = STORY_AD_TYPES.FULL, storyId = null) => {
  const params = toParams({ type, storyId });
  return API.get(`/story-ads/?${params}`);
};

const clickStoryAd = (storyAdId, type = STORY_AD_TYPES.LIST) =>
  API.post(`/story-ads/${storyAdId}/click/?type=${type}`);

export default {
  getStory,
  getStoriesByIds,
  getStoryEpisodes,
  getUserStories,
  getUserOtherStories,
  getEpisode,
  getStoryRecommendations,
  search,
  purchaseEpisode,
  readEpisode,
  getPaidChoices,
  purchaseChoice,
  previewByBalloon,
  getStoryAd,
  clickStoryAd,
};



// WEBPACK FOOTER //
// ./src/app/apis/story.js